import { Router } from 'expo-router';

/**
 * Leaves the product PDP modal stack and opens the root `menu/section/[id]` card
 * with the unavailable item pinned for deeplink chrome.
 *
 * Section is a root-stack sibling of `(modals)` (see root-layout). A string
 * `dismissTo(href)` often fails to resolve that screen; use the typed pathname.
 */
export function navigateToUnavailableMenuSection(
  router: Pick<Router, 'canDismiss' | 'dismissTo' | 'replace'>,
  sectionId: string,
  itemId: string
): void {
  const params = { id: sectionId, targetItemIds: itemId, unavailableItemId: itemId };
  const route = {
    pathname: '/menu/section/[id]' as const,
    params,
  };

  if (router.canDismiss()) {
    router.dismissTo(route);
    return;
  }

  router.replace(route);
}
